var React = require('react');

function Next (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M25.0855 24.06V1.87807C25.0855 1.42641 24.684 1.02492 24.2323 1.02492H19.1636C18.7119 1.02492 18.3104 1.42641 18.3104 1.87807V11.6642L1.5485 1.02492C1.29758 0.874367 0.946279 0.874367 0.695351 0.974737C0.444424 1.12529 0.243683 1.42641 0.243683 1.72752V24.06C0.243683 24.3611 0.394239 24.6623 0.695351 24.8128C0.845908 24.863 0.946278 24.9132 1.09683 24.9132C1.24739 24.9132 1.39795 24.863 1.5485 24.7626L18.3104 14.1735V24.06C18.3104 24.5117 18.7119 24.9132 19.1636 24.9132H24.2323C24.684 24.9132 25.0855 24.5619 25.0855 24.06Z","fill":"white"}));
}

Next.defaultProps = {"width":"26","height":"25","viewBox":"0 0 26 25","fill":"none"};

module.exports = Next;

Next.default = Next;
